import React from "react";
import { useTranslation } from "react-i18next";
import { Grid, TextField } from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import {
  heightFtOptions,
  heightInOptions,
  heightUnits,
  weightUnits,
} from "../../../../../constants/selectOptions";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CircleCheckedFilled from "@mui/icons-material/CheckCircle";
import CircleUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import { topicModalStyles } from "../../../styles/topicModalStyles";
import clsx from "clsx";
import { formClasses, FormRoot } from "../../../../../theme/formStyles";

export const Form = (props: any) => {
  const classes = topicModalStyles();
  const { t } = useTranslation(["prepFq", "common"]);
  const {
    values: {
      weight,
      height_cm,
      height_in,
      height_ft,
      weight_units,
      height_units,
      prefer_not_to_answer,
    },
    errors,
    touched,
    handleChange,
    handleSubmit,
    setFieldTouched,
  } = props;
  const change = (name: string, e: any) => {
    handleChange(e);
    setFieldTouched(name, true, false);
    if (e.target.value) {
      onSubmit(undefined);
    }
  };
  const onSubmit = (e) => {
    e?.preventDefault();
    handleSubmit();
  };
  return (
    <FormRoot className={formClasses.root} onSubmit={onSubmit}>
      <Grid spacing={1} container>
        <Grid xs={9} sm={9} md={6} lg={6} item>
          <div className={formClasses.longFormLabelContainer}>
            <FormLabel
              htmlFor="weight"
              className={clsx(formClasses.longFormLabel, classes.whiteText)}
            >
              {t("prepFq:bmi.weight.label")}
            </FormLabel>
            <TextField
              required
              id="weight"
              name="weight"
              helperText={
                touched.weight ? t(`prepFq:${errors.weight}`, "") : ""
              }
              error={touched.weight && Boolean(errors.weight)}
              fullWidth
              value={weight}
              onChange={change.bind(null, "weight")}
              variant="outlined"
              autoComplete="off"
              disabled={prefer_not_to_answer}
              type="number"
              classes={{
                root: classes.selectBorder,
              }}
              InputProps={{
                classes: {
                  input: clsx(classes.inputBackground, classes.selectText),
                },
              }}
            />
          </div>
        </Grid>
        <Grid xs={3} sm={3} md={3} lg={3} item>
          <div className={formClasses.longFormLabelContainer}>
            <FormLabel
              htmlFor="weight_units"
              className={clsx(formClasses.longFormLabel, classes.whiteText)}
            >
              {t("prepFq:bmi.weightUnits.label")}
            </FormLabel>
            <TextField
              required
              name={"weight_units"}
              id={"weight_units"}
              select
              value={weight_units}
              onChange={change.bind(null, "weight_units")}
              error={touched.weight_units && Boolean(errors.weight_units)}
              fullWidth
              helperText={
                touched.weight_units
                  ? t(`prepFq:${errors.weight_units}`, "")
                  : ""
              }
              variant="outlined"
              autoComplete="off"
              disabled={prefer_not_to_answer}
              classes={{
                root: classes.selectBorder,
              }}
              SelectProps={{
                native: true,
                classes: {
                  select: clsx(classes.selectBackground, classes.selectText),
                },
              }}
            >
              {weightUnits.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </TextField>
          </div>
        </Grid>
      </Grid>
      <Grid spacing={1} container>
        <Grid xs={9} sm={9} md={6} lg={6} item>
          {height_units === "inches" ? (
            <Grid container spacing={1}>
              <Grid xs={6} sm={6} md={6} lg={6} item>
                <div className={formClasses.longFormLabelContainer}>
                  <FormLabel
                    htmlFor="height_ft"
                    className={clsx(
                      formClasses.longFormLabel,
                      classes.whiteText
                    )}
                  >
                    {t("prepFq:bmi.height.label")}
                  </FormLabel>
                  <TextField
                    required
                    name={"height_ft"}
                    id={"height_ft"}
                    select
                    value={height_ft}
                    onChange={change.bind(null, "height_ft")}
                    error={touched.height_ft && Boolean(errors.height_ft)}
                    fullWidth
                    helperText={
                      touched.height_ft
                        ? t(`prepFq:${errors.height_ft}`, "")
                        : ""
                    }
                    variant="outlined"
                    autoComplete="off"
                    disabled={prefer_not_to_answer}
                    classes={{
                      root: classes.selectBorder,
                    }}
                    SelectProps={{
                      native: true,
                      classes: {
                        select: clsx(
                          classes.selectBackground,
                          classes.selectText
                        ),
                      },
                    }}
                  >
                    <option key={"blank"} value={""}>
                      {" "}
                    </option>
                    {heightFtOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </div>
              </Grid>
              <Grid xs={6} sm={6} md={6} lg={6} item>
                <div className={formClasses.longFormLabelContainer}>
                  <FormLabel
                    htmlFor="height_in"
                    className={clsx(
                      formClasses.longFormLabel,
                      classes.whiteText
                    )}
                  >
                    <span style={{ color: "#515475" }}>height_in</span>
                  </FormLabel>
                  <TextField
                    required
                    name={"height_in"}
                    id={"height_in"}
                    select
                    value={height_in}
                    onChange={change.bind(null, "height_in")}
                    error={touched.height_in && Boolean(errors.height_in)}
                    fullWidth
                    helperText={
                      touched.height_in
                        ? t(`prepFq:${errors.height_in}`, "")
                        : ""
                    }
                    variant="outlined"
                    autoComplete="off"
                    disabled={prefer_not_to_answer}
                    classes={{
                      root: classes.selectBorder,
                    }}
                    SelectProps={{
                      native: true,
                      classes: {
                        select: clsx(
                          classes.selectBackground,
                          classes.selectText
                        ),
                      },
                    }}
                  >
                    <option key={"blank"} value={""}>
                      {" "}
                    </option>
                    {heightInOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </div>
              </Grid>
            </Grid>
          ) : (
            <div className={formClasses.longFormLabelContainer}>
              <FormLabel
                htmlFor="height"
                className={clsx(formClasses.longFormLabel, classes.whiteText)}
              >
                {t("prepFq:bmi.height.label")}
              </FormLabel>
              <TextField
                required
                id="height_cm"
                name="height_cm"
                helperText={
                  touched.height_cm ? t(`prepFq:${errors.height_cm}`, "") : ""
                }
                error={touched.height_cm && Boolean(errors.height_cm)}
                fullWidth
                value={height_cm}
                onChange={change.bind(null, "height_cm")}
                variant="outlined"
                autoComplete="off"
                disabled={prefer_not_to_answer}
                type="number"
                classes={{
                  root: classes.selectBorder,
                }}
                InputProps={{
                  classes: {
                    input: clsx(classes.inputBackground, classes.selectText),
                  },
                }}
              />
            </div>
          )}
        </Grid>
        <Grid xs={3} sm={3} md={3} lg={3} item>
          <div className={formClasses.longFormLabelContainer}>
            <FormLabel
              htmlFor="height_units"
              className={clsx(formClasses.longFormLabel, classes.whiteText)}
            >
              {t("prepFq:bmi.heightUnits.label")}
            </FormLabel>
            <TextField
              required
              name={"height_units"}
              id={"height_units"}
              select
              value={height_units}
              onChange={change.bind(null, "height_units")}
              error={touched.height_units && Boolean(errors.height_units)}
              fullWidth
              helperText={
                touched.height_units
                  ? t(`prepFq:${errors.height_units}`, "")
                  : ""
              }
              variant="outlined"
              autoComplete="off"
              disabled={prefer_not_to_answer}
              classes={{
                root: classes.selectBorder,
              }}
              SelectProps={{
                native: true,
                classes: {
                  select: clsx(classes.selectBackground, classes.selectText),
                },
              }}
            >
              {heightUnits.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </TextField>
          </div>
        </Grid>
      </Grid>
      <FormControlLabel
        name="prefer_not_to_answer"
        classes={{
          label: classes.whiteText,
        }}
        control={
          <Checkbox
            icon={<CircleUnchecked />}
            checkedIcon={<CircleCheckedFilled />}
            color={"secondary"}
            size="small"
            checked={prefer_not_to_answer}
            onChange={change.bind(null, "prefer_not_to_answer")}
            classes={{
              root: classes.whiteText,
            }}
          />
        }
        style={{ marginTop: "8px" }}
        label={`${t("prepFq:bmi.preferNotToAnswer")}`}
      />
    </FormRoot>
  );
};
